<!-- src/views/auth/login.vue -->
<template>
  <div class="login-container">
    <h2>Login</h2>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <label for="email">E-mail</label>
        <input
          type="text"
          id="email"
          v-model="credentials.email"
          required
          placeholder="Digite seu e-mail"
        />
      </div>
      <div class="form-group">
        <label for="password">Senha</label>
        <input
          type="password"
          id="password"
          v-model="credentials.password"
          required
          placeholder="Digite sua senha"
        />
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-primary">Entrar</button>
      </div>
    </form>
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

export default {
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();
    const credentials = ref({
      email: "",
      password: "",
    });
    const errorMessage = ref(null);

    onMounted(() => {
      if (authStore.isAuthenticated) {
        router.push({ name: "dashboard" });
      }
    });
  
    const handleLogin = async () => {
      errorMessage.value = null;
      try {
        await authStore.login(credentials.value);
        router.push({ name: "dashboard" });
      } catch (error) {
        errorMessage.value = "E-mail ou senha incorretos, tente novamente!";
      }
    };

    return {
      credentials,
      errorMessage,
      handleLogin,
    };
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  margin-top: 10px;
  text-align: center;
}
</style>
